// extracted by mini-css-extract-plugin
export default {"visualShieldRootV2":"visualShieldRootV2___PgsAg","visualShieldImgV2":"visualShieldImgV2___OSZW7"};